/**
 * "新建 key"用到的最小工具集（M2 简化版）。
 *
 * 之前用来从表单 build 出整个 WatchView 的 helper（validateBuilder /
 * buildWatchView / suggestIdFromName / rowToWatcher）已随多视图 builder 一起
 * 下线；此文件保留两个核心纯函数：
 *
 *   - `escapeRegex`：把用户输入转义成正则字面量；
 *   - `patternFromKey`：键名 → extract pattern，覆盖 `key=val` / `key: val`
 *     / `key : val` 三种写法，值边界靠空格 / 逗号 / 分号断开。
 *
 * 单测见 `tests/log-watch/builder.test.ts`。
 */

const REGEX_META = /[\\^$.*+?()[\]{}|]/g;

export function escapeRegex(s: string): string {
  return s.replace(REGEX_META, '\\$&');
}

/**
 * 把用户输入的"键名"（如 `oaid`）翻译成 extract pattern：
 *   `<key>\s*[=:]\s*([^\s,;]+)`
 *
 * 设计取舍：
 *   - 兼顾 `oaid=xxx` / `oaid: xxx` / `oaid : xxx` 三种常见写法；
 *   - 值部分用 `[^\s,;]+`（不吞空白 / 逗号 / 分号），避免抽出整个尾巴；
 *   - 通过 escapeRegex(key) 防止用户输入 `.` `+` 等元字符把整行抓飞；
 *   - 不加 word-boundary：`\b` 在中文 / 下划线场景的歧义比"宽松匹配"
 *     带来的小概率多匹配更难调，宁愿宽松。
 */
export function patternFromKey(key: string): string {
  return `${escapeRegex(key.trim())}\\s*[=:]\\s*([^\\s,;]+)`;
}
